// Saving a file the backend streamed back (Excel exports, templates). The API layer
// returns the blob on `body` and the raw headers alongside it, so the filename the
// server chose travels in Content-Disposition rather than being guessed here.

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/** `attachment; filename=user_activity_1.xlsx` -> `user_activity_1.xlsx` */
export const filenameFromResponse = (response, fallback) => {
  const disposition = response?.headers?.["content-disposition"];
  const name = disposition?.split("filename=")[1]?.replaceAll('"', "").trim();
  return name || fallback;
};

/**
 * Trigger a browser download for a file response. Returns false when the response
 * carried no body, so callers can surface an error instead of saving an empty file.
 */
export const saveFileResponse = (
  response,
  fallbackName,
  mimeType = XLSX_MIME
) => {
  if (!response?.body) return false;

  const url = globalThis.URL.createObjectURL(
    new Blob([response.body], { type: mimeType })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filenameFromResponse(response, fallbackName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  globalThis.URL.revokeObjectURL(url);
  return true;
};
